<template>
  <v-container>
    <NewArticleForm v-if="$route.params.formName === 'newArticleForm'" />
    <ModifyBasicDataForm
      v-if="$route.params.formName === 'modifyBasicDataForm'"
    />
    <NewBookAndChapterForm
      v-if="$route.params.formName === 'newBookAndChapterForm'"
    />
    <NewCommunicationForm
      v-if="$route.params.formName === 'newCommunicationForm'"
    />
    <NewThesisForm v-if="$route.params.formName === 'newThesisForm'" />
  </v-container>
</template>

<script>
import NewArticleForm from "./NewArticleForm";
import ModifyBasicDataForm from "./ModifyBasicDataForm";
import NewBookAndChapterForm from "./NewBookAndChapterForm";
import NewCommunicationForm from "./NewCommunicationForm";
import NewThesisForm from "./NewThesisForm";
import axios from "axios";
export default {
  components: {
    NewThesisForm,
    NewCommunicationForm,
    NewBookAndChapterForm,
    NewArticleForm,
    ModifyBasicDataForm
  },
  name: "InvestigatorForms",

  data() {
    return {
      publication: ""
    };
  },
  methods: {
    extractPublicationTitle(publication) {
      if (!publication || typeof publication !== "object") {
        return "";
      }
      return (
        publication.title ||
        (publication.bookandchapter && publication.bookandchapter.title) ||
        (publication.bookAndChapter && publication.bookAndChapter.title) ||
        (publication.article && publication.article.title) ||
        (publication.communication && publication.communication.title) ||
        (publication.thesis && publication.thesis.title) ||
        ""
      );
    },
    setBreadcrumb() {
      let publication = {
        text: this.publication,
        exact: true,
        href: "/publications/" + this.$route.params.id,
        last: true
      };
      let form = {
        text: "section." + this.$route.params.formName,
        disabled: true,
        last: true
      };
      if (
        !this.$route.meta.breadCrumb.some(breadcrumb => {
          return breadcrumb.last === true;
        })
      ) {
        if (this.$route.meta.update) {
          this.$route.meta.breadCrumb.push(publication);
        }
        this.$route.meta.breadCrumb.push(form);
      } else {
        this.$route.meta.breadCrumb.pop();
        if (this.$route.meta.update) {
          this.$route.meta.breadCrumb.pop();
          this.$route.meta.breadCrumb.push(publication);
        }
        this.$route.meta.breadCrumb.push(form);
      }
      this.$store.state.sectionTitle = "section." + this.$route.params.formName;
    },
    getPublication() {
      if (this.$route.params.formName === "modifyBasicDataForm" && this.$route.meta.update) {
        const path =
          this.$store.state.endpoint +
          "/publication/" +
          this.$route.params.id;
        axios
          .get(path)
          .then(response => {
            this.publication = this.extractPublicationTitle(response.data);
          })
          .finally(() => {
            this.setBreadcrumb();
          })
          .catch(error => {
            console.log(error);
          });
      } else{
        this.setBreadcrumb();
      }
    }
  },

  created() {
    this.getPublication();
  },

  updated() {
    this.getPublication();
  }
};
</script>

<style scoped></style>
